export default __webpack_public_path__ + "static/media/gallery_21.f2ea956e.jpg";